// extracted by mini-css-extract-plugin
module.exports = {"linkbox":"contentBox__linkbox39S","header":"contentBox__headerVA9","image":"contentBox__image2UW","text":"contentBox__text3ib","link":"contentBox__linkN2z"};